import Content from "../common/Content"
import Footer from "../common/Footer"
import Header from "../common/Header"
import { API } from "../../helper/Api";
import { useSearchParams,useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RotatingLines } from 'react-loader-spinner'
import SessionHandler from '../common/SessionHandler';
import RichTextEditor from "../common/RichTextEditor";
import { type } from "@testing-library/user-event/dist/type";
import Multiselect from "multiselect-react-dropdown";
import { useRole } from "../contextApi/RoleContext";
import Select from "react-select"; // Import React Select
import makeAnimated from 'react-select/animated';


export default function CatalogPriceUpdate(){
  const animatedComponents = makeAnimated();
    const { setRole, role, setPermission, permission, setUserDetails,userDetails} =
    useRole();
    const API_URL = process.env.REACT_APP_BASE_URL;
    // let id  = useSearchParams(); 
    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id')
    const [postValue, setPosts] = useState([]);
    const [stores, setStores] = useState([]);
    const [title , setTitle] = useState("");
    const [invenType , setInvenType] = useState("");
    const [itemnumber , setItemnumber] = useState("");
    const [price , setPrice] = useState("");
    const [availableOnWebStatus , setAvailableOnWebStatus] = useState("");
    const [availableOnWeb , setAvailableOnWeb] = useState(false);
    
    const [plu , setPLU] = useState("");
    const [clu , setCLU] = useState("");
    const [upc , setUPC] = useState("");
    const [newPrice , setnewPrice] = useState("");
    const navigate = useNavigate();
    const [pending, setPending] = useState(true);
    const [store, setStore] = useState("");
    const [deptName, setDeptName] = useState("");
    const [deptClassName, setDeptClassName] = useState("");
    const [productCode, setProductCode] = useState(0);
    const [prices, setPrices] = useState([]);
    const [batteries, setBatteries] = useState(false);
    const [chokingHazard, setChokingHazard] = useState(false);
    const [nso, setNso] = useState(false);
    const [leExclusive, setLEExclusive] = useState(false);
    const [extraShippingCharge, setExtraShippingCharge] = useState(false);
    const [gender, setGender] = useState("");
    const [giftWrap, setGiftWrap] = useState(false);
    const [ageAppropriateness, setAgeAppropriateness] = useState("");
    const [batteryType, setBatteryType] = useState("");
    const [lowAge, setLowAge] = useState("");
    const [highAge, setHighAge] = useState("");
    const [shippingType, setShippingType] = useState("");
    const [leItemCategory, setLEItemCategory] = useState("");
    const [leCurrentCatalog, setLECurrentCatalog] = useState("");
    const [status, setStatus] = useState("");
    const [individualAges, setIndividualAges] = useState([]);
    const [interests, setInterests] = useState([]);
    const [skillBuilder, setSkillBuilder] = useState([]);
    const [leCatalogDesignation, setLECatalogDesignation] = useState([]);
    const [trendCategory, setTrendCategory] = useState([]);
    const [webDescription, setWebDescription] = useState("");
    const [reason, setReason] = useState("");
    const [franchiseGroupCode, setFranchiseGroupCode] = useState("");
    const [webLongDescription, setWebLongDescription] = useState("");
    const [webShortDescription, setWebShortDescription] = useState("");
    const [metawords, setMetawords] = useState("");
    const [taxCategory, setTaxCategory] = useState("");

      //Vendor Information
  const [primaryvendors, setPrimaryVendor] = useState("");
  const [secondaryvendor, setSecondaryVendor] = useState("");
  const [allvendors, setAllVendors] = useState([]);
  const [primaryVlu, setPrimaryVlu] = useState("");
  const [primaryminQty, setPrimaryMinQty] = useState(0);
  const [primaryorderCost, setPrimaryOrderCost] = useState(0);
  const [secondaryVlu, setSecondaryVlu] = useState("");
  const [secondaryminQty, setSecondaryMinQty] = useState(0);
  const [secondaryorderCost, setSecondaryOrderCost] = useState(0);
  const [storeCode, setStoreCode] = useState([]);
  // const [primaryVendor, setPrimaryVendor] = useState("");

   // Basic Information
   const [casePack, setCasePack] = useState();
   const [orderByCase, setOrderByCase] = useState(false);

  //skill builder default option
  const skillBuilderOption =[
    {Description: "Fine Motor", value: "1", label: "Fine Motor Skills"},
    {Description: "Gross Motor", value: "2", label: "Gross Motor Skills"},
    {Description: "Language & Speech", value: "3", label: "Language and Speech Development"},
    {Description: "Cognitive", value: "4", label: "Cognitive Development"},
    {Description: "Visual & Spatial Perception", value: "5", label: "Visual & Spatial Perception Skills"},
    {Description: "Social Skills & Self-Esteem", value: "6", label: "Social Skills & Self-Esteem"},
    {Description: "Sensory Processing", value: "7", label: "Sensory Processing Skills"},
    {Description: "Oral Motor", value: "8", label: "Oral Motor Skills"}
  ];

  //le catalog designation
  const catalogDesignationOpt=[
    { ID: 1, "Catalog Designation": "January Catalog", label: "January Catalog", value: 1 },
    { ID: 2, "Catalog Designation": "February Catalog", label: "February Catalog", value: 2 },
    { ID: 3, "Catalog Designation": "March Catalog", label: "March Catalog", value: 3 },
    { ID: 4, "Catalog Designation": "April Catalog", label: "April Catalog", value: 4 },
    { ID: 5, "Catalog Designation": "May Catalog", label: "May Catalog", value: 5 },
    { ID: 6, "Catalog Designation": "June Catalog", label: "June Catalog", value: 6 },
    { ID: 7, "Catalog Designation": "July Catalog", label: "July Catalog", value: 7 },
    { ID: 8, "Catalog Designation": "August Catalog", label: "August Catalog", value: 8 },
    { ID: 9, "Catalog Designation": "September Catalog", label: "September Catalog", value: 9 },
    { ID: 10, "Catalog Designation": "October Catalog", label: "October Catalog", value: 10 },
    { ID: 11, "Catalog Designation": "November Catalog", label: "November Catalog", value: 11 },
    { ID: 12, "Catalog Designation": "December Catalog", label: "December Catalog", value: 12 }
  ]
   
  //item interest

  const interestOpt=[
    { "value": "3709", "label": "Infant" },
    { "value": "3713", "label": "Party Favors" },
    { "value": "3714", "label": "Tween" },
    { "value": "3720", "label": "Preschool" },
    { "value": "3728", "label": "Toddler" },
    { "value": "3751", "label": "Pretend Play" },
    { "value": "4093", "label": "Books" },
    { "value": "4100", "label": "Science" },
    { "value": "4120", "label": "Ride-Ons" },
    { "value": "4927", "label": "Health and Safety" },
    { "value": "7191", "label": "Best Sellers" },
    { "value": "7192", "label": "Stuffed Animals" },
    { "value": "7193", "label": "Games" },
    { "value": "7194", "label": "Boredom Busters" },
    { "value": "7194", "label": "Health & Safety" },
    { "value": "7195", "label": "Father's Day" },
    { "value": "7196", "label": "Arts & Creativity" },
    { "value": "7197", "label": "Construction" },
    { "value": "7198", "label": "Collectables" },
    { "value": "7199", "label": "Bunny Buffet" },
    { "value": "7200", "label": "Summer" },
    { "value": "7201", "label": "Dolls" },
    { "value": "7203", "label": "Fashion" },
    { "value": "7204", "label": "Accessories" },
    { "value": "7205", "label": "Room Decor" },
    { "value": "7206", "label": "Mother's Day" },
    { "value": "7207", "label": "Musical Toys" },
    { "value": "7208", "label": "Fidget Toys" },
    { "value": "7209", "label": "Travel Toys" },
    { "value": "7210", "label": "Educational" },
    { "value": "7211", "label": "Puzzles & Brainteasers" },
    { "value": "7212", "label": "S.T.E.A.M" },
    { "value": "7213", "label": "Valentine's" },
    { "value": "7214", "label": "Spring" },
    { "value": "7215", "label": "Gadgets" },
    { "value": "7216", "label": "Easter" },
    { "value": "7217", "label": "Stocking Stuffers" },
    { "value": "7218", "label": "Christmas" },
    { "value": "7219", "label": "Winter" },
    { "value": "7220", "label": "Personalization" },
    { "value": "7221", "label": "Halloween" },
    { "value": "9946", "label": "Fall" },
    { "value": "10329", "label": "None" },
    { "value": "11128", "label": "Classic Wood" },
    { "value": "13169", "label": "Custom Gift Boxes" },
    { "value": "18927", "label": "Gift Cards" },
    { "value": "19016", "label": "Action-Skill-Sports" },
    { "value": "19024", "label": "Vehicles and Remote Control" },
    { "value": "19027", "label": "Lego" },
    { "value": "19029", "label": "Candy" },
    { "value": "19033", "label": "Chanukkah" },
    { "value": "19042", "label": "Squishmallows" }
  ];

  const [showModal, setShowModal] = useState(false);


  const getvendors = () => {
    API.getVendors()
      .then((datas) => {
        const Allvendors = datas.ApiDocument.Response.Vendors.flatMap(
          (Allvendors) => Allvendors
        );
       // console.log("all vendors",Allvendors);
        setAllVendors(Allvendors);
      })
      .catch((err) => console.log(err));
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };
    // const [updateTitle , setupdateTitle] = useState([]);

    ///get the store code /////
   const fetchStoreCode = async () => {
    try {
      const res = await fetch(`${API_URL}location.php`);
      // Check if the response is successful (status 200)
      if (!res.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await res.json();
      console.log(result)
      const extractCode = result.ApiDocument.Response.Locations.map(
        (item) => {
          return { code: item.Code,name: item.Name };
        }
      ).filter((item) => item.code);
   //   console.log("test",extractCode)
      setStoreCode(extractCode);
      // if(userDetails.usertype !=="CORP"){
      //   const filterCodeBasedOnUser= extractCode.filter(item => userDetails.storecode.some(its=> its.storecode === item.code));
      //   setStoreCode(filterCodeBasedOnUser);
      //   console.log("filtered code",filterCodeBasedOnUser)
      // }else{
      //   setStoreCode(extractCode);
      // }
      
      
      // console.log("store code", extractCode);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //////////////////////////////

  ///captalize the option ///

  const capitalizeWords = (str) => {
    return str
      .split(' ') 
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' '); 
  };
  


  //////end/////////////////

    useEffect(()=>{
      fetchStoreCode();
    },[])

    useEffect(() => {
        API.getSpecificData({id})
        .then(datas => {
          const items = datas.ApiDocument.Response.Styles.flatMap(style => style);
          console.log(items);
          setPosts(items);
          setPending(false);
        })
        .catch((err) => console.log(err))
        getvendors();
    }, [id]);

    useEffect(() => {
      if(postValue[0] != undefined){
        ///update vendor field//

console.log("vendor len",postValue[0].Vendors);
if(postValue[0].Vendors.length > 0){
  const primaryVendor =postValue[0].Vendors.filter(item=> item.IsPrimary === true);
  const secondaryVendor =postValue[0].Vendors.filter(item=> item.IsPrimary === false);
  console.log("find vendor",primaryVendor);
    if(primaryVendor.length > 0){
      //console.log("is primary",)
        //set primary vendor value
        setPrimaryVendor(primaryVendor[0].VendorIdentifier);
        setPrimaryOrderCost(primaryVendor[0].OrderCost)
        setPrimaryMinQty(primaryVendor[0].VendorDetails[0].MinQty)
        setPrimaryVlu(primaryVendor[0].VendorDetails[0].VLU)
    }
    if(secondaryVendor.length > 0){
        ///set secondary vendor value
        setSecondaryVendor(secondaryVendor[0].VendorIdentifier)
        setSecondaryOrderCost(secondaryVendor[0].OrderCost)
        setSecondaryMinQty(secondaryVendor[0].VendorDetails[0].MinQty)
        setSecondaryVlu(secondaryVendor[0].VendorDetails[0].VLU)
    }
    
}
        /////end///////
        setStores(postValue[0].Items[0].Prices);
        setTitle(postValue[0].StoreDescription);
        setInvenType(postValue[0].InvenType);
        setItemnumber(postValue[0].Items[0].CLU);
        setPLU(postValue[0].Items[0].PLU );
        setCLU(postValue[0].Items[0].CLU );
        setUPC(postValue[0].Items[0].UPC );
        setPrice(postValue[0].Items[0].BasePrice);
        setDeptName(postValue[0].DCSS.DeptName);
        setDeptClassName(postValue[0].DCSS.ClassName);
        setProductCode(postValue[0].StyleNo);
       
        const getUpdatedPrice =postValue[0].Items[0].Prices?.map((item)=>{
          let matchedStoreCode = storeCode.find(it=> it.code === item.PriceLevel)
          if(matchedStoreCode){
            return {...item,strname:matchedStoreCode.name}
          }else{
            return {...item,strname:''}
          }
            
        })
        const sortedData = getUpdatedPrice.sort((a, b) => {
          if (a.strname.toLowerCase() < b.strname.toLowerCase()) {
            return -1;
          }
          if (a.strname.toLowerCase() > b.strname.toLowerCase()) {
            return 1;
          }
          return 0;
        });
      //  let sort=getUpdatedPrice
        console.log("all price$$$$",sortedData)
        setPrices(getUpdatedPrice);

        if(postValue[0].EChannels){
        setAvailableOnWebStatus(postValue[0].EChannels[0].Status);
        setAvailableOnWeb(true);

        }

        console.log(availableOnWeb)
        setBatteries(postValue[0].Custom.CustomFlag1);
        setOrderByCase(postValue[0].Items[0].Custom.CustomFlag1);
        setCasePack(postValue[0].Items[0].Custom.CustomNumber1);
        setChokingHazard(postValue[0].Custom.CustomFlag2);
        setNso(postValue[0].Custom.CustomFlag3);
        setLEExclusive(postValue[0].Custom.CustomFlag4);
        setExtraShippingCharge(postValue[0].Custom.CustomFlag5);
        setGiftWrap(postValue[0].Custom.CustomFlag6);
        
        if(postValue[0].Custom.CustomLookup1){
          setAgeAppropriateness(postValue[0].Custom.CustomLookup1);
        }
        
        setBatteryType(postValue[0].Custom.CustomLookup2);
        //set gender option
        switch(postValue[0].Custom.CustomLookup3){
          case "0": setGender("Boy"); break;
          case "1": setGender("Girl"); break;
          case "2": setGender("Both"); break;
          default: setGender(""); break;
          
        }
       
        setLowAge(postValue[0].Custom.CustomLookup4);
        setHighAge(postValue[0].Custom.CustomLookup5);
        setShippingType(postValue[0].Custom.CustomLookup6);
        setLEItemCategory(postValue[0].Custom.CustomLookup7);
        setLECurrentCatalog(postValue[0].Custom.CustomLookup8);
        setStatus(postValue[0].Custom.CustomLookup12);
        setIndividualAges(postValue[0].Custom.CustomMultiselects1);
        if(postValue[0].TaxCategory !==""){
            let taxOpt="";
            switch(postValue[0].TaxCategory) {
                case "1":
                    taxOpt = "Standard Retail";
                    break;
                case "2":
                    taxOpt = "Non-taxable";
                    break;
                case "3":
                    taxOpt = "Apparel";
                    break;
                case "4":
                    taxOpt = "Food";
                    break;
                default:
                    taxOpt = "";
            }
            setTaxCategory(taxOpt);
            console.log("tax",taxOpt)
        }
        //modify the interest option
        if(postValue[0].Custom.CustomMultiselects2 && postValue[0].Custom.CustomMultiselects2.length > 0){
            const interestOpt1 = interestOpt.filter(item => postValue[0].Custom.CustomMultiselects2.some(item1 => item1.LookupName === item.value));
            setInterests(interestOpt1);
        }
        
        //modify the skill builder option
        if(postValue[0].Custom.CustomMultiselects3 && postValue[0].Custom.CustomMultiselects3.length > 0 ){
            const skillOpt = skillBuilderOption.filter(item => postValue[0].Custom.CustomMultiselects3.some(item1 => item1.LookupName === item.value));
            setSkillBuilder(skillOpt);
        }
       
        //modify the catalog designation
        if(postValue[0].Custom.CustomMultiselects4 && postValue[0].Custom.CustomMultiselects4.length > 0){
            const catalogOpt = catalogDesignationOpt.filter(item => postValue[0].Custom.CustomMultiselects4.some(item1 => Number(item1.LookupName) === item.ID));
           console.log("designation",catalogOpt)
            setLECatalogDesignation(catalogOpt);
        }
      
       
        
        setTrendCategory(postValue[0].Custom.CustomMultiselects5);
        setWebDescription(postValue[0].Custom.CustomText1);
        setReason(postValue[0].Custom.CustomText11);
        setFranchiseGroupCode(postValue[0].Custom.CustomText12);
        setWebShortDescription(postValue[0].CustomLongText1);
        setWebLongDescription(postValue[0].CustomLongText2);
        setMetawords(postValue[0].CustomLongText3);

      }
    }, [postValue[0]]);   


    const updateCallBack = (result) =>{
        if(result.Id) {
            toast.success('Price Updated', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
                });
            setTimeout(() => {
              window.location.reload();

                // navigate("/catalog-list");
              }, 3000);            
            //return navigate("/catalog-list");
        } 
    }
  const handleInputChange = (index, event) => {
    const newPrice = event.target.value;
    const updatedPrices = [...prices]; 
    updatedPrices[index].newPrice = newPrice; 
    setPrices(updatedPrices); 
  };

    const updatePrice = (e) => {
       e.preventDefault();
      //  setStore(e.target.form.store.value);
      //  const oldprice = e.target.form.oldprice.value;
      //  const itemnumber = e.target.form.itemnumber.value;
      //  const newprice = e.target.form.newprice.value;
       API.updateCatalogPrice({ store,itemnumber,prices })
         .then(result => updateCallBack(result))
         .catch(error => console.log('error', error));
      
    }
    const   storeChange = (e) => {
      setStore(e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text);
      const selectStore = e.target.options[e.target.selectedIndex].text;
      setPrice(e.target.value);
      const selectedStore = stores.find((member) => member.PriceLevel === selectStore);
      if (selectedStore) {
        setPrice(selectedStore.Price);
      }
      // this.setState({
      //     selectedOption: target.value,
      // });
    }


    // const RenderData = () => {
        return (
            <>
<ToastContainer
position="top-center"
autoClose={500}
hideProgressBar={false}
newestOnTop={false}
closeOnClick
rtl={false}
pauseOnFocusLoss
draggable
pauseOnHover
theme="colored"
/>




{/* <div class="main-panel">
  <div class="content-wrapper">

  </div> 

</div>   */}


<div class="container-fluid page-body-wrapper">
        <div class="main-panel">
          <div class="content-wrapper">
          {postValue.length > 0 ? (
  <>

        <div class="header">
            <div>
                <h1>Item Master View</h1>
                <p>Manage your inventory items</p>
            </div>
            {/* <div class="btn-group">
                <button class="btn btn-primary" onClick={newCatalog}>Save Changes</button>
            </div> */}
        </div>

        <form>

            <div class="section section-blue">
                <h2>BASIC INFO</h2>
                <div class="grid grid-3">
                    <div class="form-group">
                        <label class="required">Type</label>
                        <input type="text" value={invenType} />
                    </div> 
                    <div class="form-group">
                        <label class="required">CLU</label>
                        <input type="text" class="form-control" id="clu" value={clu}/>
                    </div>                                     
                    {/* <div class="form-group">
                        <label class="required">Product Code</label>
                        <input type="text" placeholder="Enter code" value={productCode} />
                    </div> */}
                    <div class="form-group" >
                        <label class="required">Product Description</label>
                        <input type="text" class="form-control" id="description" value={title}/>
                        </div>

                    <div class="form-group">
                        <label class="required">UPC</label>
                        <input type="text" id="upc" placeholder="Enter UPC" value={upc}/>
                    </div>
                    <div class="form-group" style={{marginTop:"6px"}}>
                    <label>Case Pack</label>
                    <input type="text" id="upc" value={casePack} />
                  </div>

                  <div class="form-group" style={{marginTop:"6px"}}>
                    <label>Order By Case</label>
                    <div className="orderbycase_checkbox">
                          <label className={`switch3 ${orderByCase ? 'switch3-checked' : ''}`} >
                                <input type="checkbox" checked={orderByCase}  />
                                <div></div>
                          </label>
                        </div>
                    
                  </div>
                   <div class="form-group">
                        <label class="required">DCSS</label>
                        <input type="text" value={deptName} />
                    </div>
                    <div class="form-group" style={{marginTop:"6px"}}>
                        <label>Department</label>
                        <input type="text" value={deptName} />
                    </div>
                    <div class="form-group" style={{marginTop:"6px"}}>
                        <label>Class</label>
                        <input type="text" value={deptClassName} />
                    </div>


                </div>
            </div>

            {/* <div class="section section-gray">
                <h2 >Classification</h2>
                <div class="grid grid-3">
                    <div class="form-group">
                        <label>Subclass 1</label>
                        <input type="text" />
                    </div>
                    <div class="form-group">
                        <label>Subclass 2</label>
                        <input type="text" />
                    </div>
                </div>
            </div> */}
 <div class="section section-green">
                <h2 >VENDOR INFO</h2>
                <div class="grid grid-4">
                    <div class="form-group">
                        <label class="required">Primary Vendor</label>
                        <select class="form-control" id="store" value={primaryvendors} required>
                      <option value="">Select Vendor</option>
                      {allvendors.map((vendor, index) => (
                        <option value={vendor.VendorCode}>
                          {capitalizeWords(vendor.Name)} (#{vendor.VendorCode})
                        </option>
                      ))}
                    </select>
                    </div>
                    <div class="form-group">
                        <label class="required">Primary Order Cost</label>
                        <input type="number" step="0.01" value={primaryorderCost}/>
                    </div>
                    <div class="form-group">
                        <label class="required">Primary Min Order Qty</label>
                        <input type="number" placeholder="0" value={primaryminQty} />
                    </div>                    
                    <div class="form-group">
                        <label class="required">Primary VLU</label>
                        <input type="text" placeholder="Enter VLU" value={primaryVlu}  /> 
                    </div>
                </div>
                <div class="grid grid-4">
                  <div class="form-group">
                    <label>Secondary Vendor</label>
                    <select
                      class="form-control"
                      id="store"
                      value={secondaryvendor}
                    >
                      <option value="">Select Vendor</option>
                      {allvendors.map((vendor, index) => (
                        <option value={vendor.VendorCode}>
                          {capitalizeWords(vendor.Name)} (#{vendor.VendorCode})
                        </option>
                      ))}
                    </select>
                    {/* <input type="text" value={secondaryvendor} /> */}
                    
                  </div>
                  <div class="form-group">
                    <label>Secondary Order Cost </label>
                    <input
                      type="number"
                      step="0.01" value={secondaryorderCost}
                    />
                  </div>
                  <div class="form-group">
                    <label>Secondary Min Order Qty</label>
                    <input
                      type="number"
                      placeholder="0"
                      value={secondaryminQty}
                    />
                  </div>
                  <div class="form-group">
                    <label>Secondary VLU</label>
                    <input
                      type="text"
                      placeholder="Enter VLU"
                      value={secondaryVlu}
                    />
                  </div>
                </div>
            </div>
{userDetails.usertype.trim() ==="CORP" ? (
          <div class="section section-gray">
                <h2 className="pricelevel_title">Price Level</h2>
                <div class="grid grid-3">
                  <div class="form-group">
                    <div>
                      {/* Modal */}
                      <div
                        className={`modal fade ${showModal ? "show" : ""}`}
                        tabIndex="-1"
                        style={{ display: showModal ? "block" : "none" }}
                        aria-hidden={!showModal}
                      >
                        <div className="modal-dialog modal-lg">
                          {" "}
                          {/* Add modal-lg class here for large modal */}
                          <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                              <h5 className="modal-title">
                                All Store Price Level
                              </h5>
                              <button
                                type="button"
                                className="close"
                                onClick={toggleModal}
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>

                            {/* Modal Body */}
                            <div className="modal-body">
                              <div class="grid grid-4">
                                {prices.map((priceLevel, index) => {
                                    if(priceLevel.PriceLevel !=="BASEPRICE")
                                   return <div class="form-group">
                                    <label>{priceLevel.strname} (#{priceLevel.PriceLevel})</label>
                                    <input
                                      type="number"
                                      className="priceLevel"
                                      id={priceLevel.PriceLevel}
                                      value={priceLevel.Price}
                                     
                                    />
                                  </div>
                                }
                                  
                                )}
                              </div>
                            </div>

                            {/* Modal Footer */}
                            <div className="modal-footer">
                              {/* <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                Close
              </button> */}
                              {/* <button type="button" className="btn btn-primary" onClick={toggleModal}>
                Save changes
              </button> */}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Optional: Overlay for modal */}
                      {showModal && (
                        <div className="modal-backdrop fade show" />
                      )}
                    </div>
                    <label class="required">Base Price</label>
                    <input type="text" class="form-control" id="baseprice" value={price}  />
                  </div>
                  <div class="form-group store_price_update_btn">
                    <input class="btn btn-primary" onClick={toggleModal} value="View Store Price" />
                  </div>
                </div>
                {/* <div class="grid grid-3">
                  {priceLevels.map((priceLevel,index) =>(
                        <div class="form-group">
                        <label>{priceLevel.Description}</label>
                        <input type="number"  id={priceLevel.Code} onChange={(e) => handleChange(e, priceLevel.Code)}/>
                    </div>                    
                  ))}
                </div> */}
              </div>
         ):(
          <div class="section section-gray">
          <h2 className="pricelevel_title">Price Level</h2>
    <div class="grid grid-4">
    {prices.filter(item=> userDetails.storecode.some(item2 => item2.storecode ===item.PriceLevel)).map((priceLevel, index) => (
                          <div class="form-group">
                            <label>{priceLevel.strname} (#{priceLevel.PriceLevel})</label>
                            <input type="number" className="priceLevel" id={priceLevel.PriceLevel} value={priceLevel.Price} 
                               
                            />
                          </div>
                        ))}</div>
  </div>
          
         )}   


           


             <div class="section section-purple">
                <h2>ITEM ATTRIBUTES</h2>
                <div class="grid grid-3">
                    <div class="form-group">
                        <label>Gender</label>
                        <input type="text" value={gender}/>
                    </div>
                    <div class="form-group">
                        <label>Low Age</label>
                        <input type="text" value={lowAge}/>
                    </div>                       
                    <div class="form-group">
                        <label>High Age</label>
                        <input type="text" value={highAge}/>
                    </div> 
                    <div class="form-group">
                        <label>Individual Ages</label>
                        <input type="text" value={individualAges?.length > 0 ? individualAges.map(item => item.LookupName).join(','):""} />
                    </div>                    

                    <div class="form-group">
                        <label>Age Appropriateness</label>
                        <input type="text"  value={capitalizeWords(ageAppropriateness)}/>
                    </div>

                    <div class="form-group">
                        <label>Skill Builder</label>
                       {/* <input type="text" value={skillBuilder} /> */}
                       
                        {/* <Multiselect 
                              id="skillbuilder"
                              displayValue="Description"
                              // ref={multiselectRef}
                              selectedValues={skillBuilder}
                              hidePlaceholder={true}
                              placeholder=""
                         />  */}
                         <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      // onChange={handleSkillBuilders}
      // onRemove={handleStoreCode}
       value={skillBuilder}
      // options={[
      //   {Description: "Fine Motor", value: "1", label: "Fine Motor Skills"},
      //   {Description: "Gross Motor", value: "2", label: "Gross Motor Skills"},
      //   {Description: "Language & Speech", value: "3", label: "Language and Speech Development"},
      //   {Description: "Cognitive", value: "4", label: "Cognitive Development"},
      //   {Description: "Visual & Spatial Perception", value: "5", label: "Visual & Spatial Perception Skills"},
      //   {Description: "Social Skills & Self-Esteem", value: "6", label: "Social Skills & Self-Esteem"},
      //   {Description: "Sensory Processing", value: "7", label: "Sensory Processing Skills"},
      //   {Description: "Oral Motor", value: "8", label: "Oral Motor Skills"}
      // ]} 
      placeholder="Select Skill Builder" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />                  
                    </div> 
                    <div class="form-group">
                        <label>Battery Type :</label>
                        <input type="text" value={batteryType}/>
                    </div>  
                    <div class="form-group">
                      <div class="switchs">
                      <div class="form-group">
                            <label>Gift Wrap</label>
                            <div className="gift_wrap_checkbox">
                            <label className={`switch3 ${giftWrap ? 'switch3-checked' : ''}`} >
                                    <input type="checkbox" checked={giftWrap} />
                                    <div></div>
                            </label>
                            </div>
                        </div>
                        <div class="form-group">

                            <label>NSO</label>
                            <div className="nso_checkbox">
                              <label className={`switch3 ${nso ? 'switch3-checked' : ''}`} >
                                    <input type="checkbox" checked={nso}  />
                                    <div></div>
                              </label>
                            </div>
                            </div>
                            <div class="form-group">
                              <label>LE Exclusive</label>
                              <div className="le_exclusive_checkbox">
                                <label className={`switch3 ${leExclusive ? 'switch3-checked' : ''}`} >
                                      <input type="checkbox" checked={leExclusive}  />
                                      <div></div>
                                </label>
                              </div>
                          </div> 

                      </div>


                    </div> 

                    <div class="form-group">
                              <label>Choking Hazard</label>
                              <div className="choking_hazard_checkbox">
                              <label className={`switch3 ${chokingHazard ? 'switch3-checked' : ''}`} >
                                      <input type="checkbox" checked={chokingHazard} />
                                      <div></div>
                                </label>
                              </div>
                          </div>
                    


                  
                    {/* <div class="form-group">
                        <label>Batteries</label>
                        <div className="batteries_checkbox">
                        <label className={`switch3 ${batteries ? 'switch3-checked' : ''}`} >
                                <input type="checkbox" checked={batteries} />
                                <div></div>
                          </label>
                        </div>
                    </div> */}
                   
                    {/*
                    <div class="form-group">
                        <label>Date Test - Brian + Diego</label>
                        <input type="text" />
                    </div> */}

                    {/* <div class="form-group">
                        <label>Franchise Group Code</label>
                        <input type="text" value={franchiseGroupCode}/>
                    </div> */}                                                                                                                                                                                                                          
                </div>
            </div> 

            <div class="section section-gray">
                <h2>LE INFO</h2>
                <div class="grid grid-3">
                    <div class="form-group">
                        <label>LE Item Category</label>
                        <select class="form-control" id="itemcategory" onChange={(e) =>setLEItemCategory(e.target.value)} value={leItemCategory} >
                        <option value="">Select LE Item Category</option>
                      <option value="1">{capitalizeWords('ART')}</option>
<option value="2">{capitalizeWords('BOOKS')}</option>
<option value="3">{capitalizeWords('CARDS/STICKERS')}</option>
<option value="4">{capitalizeWords('ACTION/SKILL SPORTS')}</option>
<option value="5">{capitalizeWords('ROOM DECOR')}</option>
<option value="6">{capitalizeWords('GAMES')}</option>
<option value="7">{capitalizeWords('DOLLS')}</option>
<option value="8">{capitalizeWords('INFANT (0-12MOS)')}</option>
<option value="9">{capitalizeWords('CONSTRUCTION')}</option>
<option value="10">{capitalizeWords('MUSIC/CASSETTE/CD')}</option>
<option value="11">{capitalizeWords('PARTY FAVORS')}</option>
<option value="12">{capitalizeWords('PLUSH')}</option>
<option value="13">{capitalizeWords('PRESCHOOL (3-5YRS)')}</option>
<option value="14">{capitalizeWords('SCIENCE')}</option>
<option value="15">{capitalizeWords('TRANSIT')}</option>
<option value="16">{capitalizeWords('PUZZLES')}</option>
<option value="17">{capitalizeWords('WHIZ KIDS')}</option>
<option value="18">{capitalizeWords('TWEEN 7+')}</option>
<option value="19">{capitalizeWords('TEEN 13+')}</option>
<option value="21">{capitalizeWords('CANDY')}</option>
<option value="22">{capitalizeWords('COLLECTABLES')}</option>
<option value="23">{capitalizeWords('BACK TO SCHOOL')}</option>
<option value="24">{capitalizeWords('COMPOUNDS')}</option>
<option value="27">{capitalizeWords('PERSONALIZING')}</option>
<option value="28">{capitalizeWords('DVDs')}</option>
<option value="30">{capitalizeWords('DISPLAYS')}</option>
<option value="31">{capitalizeWords('FLOOR FIXTURES')}</option>
<option value="32">{capitalizeWords('G.O.G')}</option>
<option value="35">{capitalizeWords('SOFTWARE')}</option>
<option value="40">{capitalizeWords('SEASONAL')}</option>
<option value="41">{capitalizeWords('LICENSED SPORTS')}</option>
<option value="42">{capitalizeWords('TRAVEL')}</option>
<option value="43">{capitalizeWords('TODDLER (12-24MOS)')}</option>
<option value="44">{capitalizeWords('TEACHER')}</option>
<option value="55">{capitalizeWords('BIRTHDAY PARTIES')}</option>
<option value="56">{capitalizeWords('REUSABLE BAG')}</option>
<option value="60">{capitalizeWords('GIFTS')}</option>
<option value="90">{capitalizeWords('DONATIONS')}</option>
<option value="91">{capitalizeWords('GIFT CARDS')}</option>
<option value="92">{capitalizeWords('MISCELLANEOUS ITEMS')}</option>
<option value="98">{capitalizeWords('FOOD')}</option>
<option value="99">{capitalizeWords('COUPON')}</option>
<option value="211">{capitalizeWords('HEALTH & SAFETY')}</option>

                  </select>
                        {/* <input type="text"  value={leItemCategory}/> */}
                    </div> 
                    <div class="form-group">
                        <label>LE Current Catalog</label>
                        <select class="form-control"  onChange={(e) =>setLECurrentCatalog(e.target.value)} value={leCurrentCatalog}>
                        <option value="">Select LE Current Catalog</option>
                      <option value="C01">{capitalizeWords('JANUARY CATALOG')}</option>
<option value="C02">{capitalizeWords('FEBRUARY CATALOG')}</option>
<option value="C03">{capitalizeWords('MARCH CATALOG')}</option>
<option value="C04">{capitalizeWords('APRIL CATALOG')}</option>
<option value="C05">{capitalizeWords('MAY CATALOG')}</option>
<option value="C06">{capitalizeWords('JUNE CATALOG')}</option>
<option value="C07">{capitalizeWords('JULY CATALOG')}</option>
<option value="C08">{capitalizeWords('AUGUST CATALOG')}</option>
<option value="C09">{capitalizeWords('SEPTEMBER CATALOG')}</option>
<option value="C10">{capitalizeWords('OCTOBER CATALOG')}</option>
<option value="C11">{capitalizeWords('NOVEMBER CATALOG')}</option>
<option value="C12">{capitalizeWords('DECEMBER CATALOG')}</option>
                    </select>
                        {/* <input type="text" value={leCurrentCatalog}/> */}
                    </div> 
                    <div class="form-group">
                        <label>LE Catalog Designation</label>
                        {/* <Multiselect
                                                              id="catalogdesignation"
                                                              displayValue="Catalog Designation"
                                                              // ref={multiselectRef}
                                                             selectedValues={leCatalogDesignation}
                                                             
                                                              placeholder=""
                                                              hidePlaceholder={true}
                                                            /> */}
                                                            <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      // onChange={handleDesignation}
      // onRemove={handleStoreCode}
       value={leCatalogDesignation}
      // options={[
      //   { ID: 1, "Catalog Designation": "January Catalog", label: "January Catalog", value: 1 },
      //   { ID: 2, "Catalog Designation": "February Catalog", label: "February Catalog", value: 2 },
      //   { ID: 3, "Catalog Designation": "March Catalog", label: "March Catalog", value: 3 },
      //   { ID: 4, "Catalog Designation": "April Catalog", label: "April Catalog", value: 4 },
      //   { ID: 5, "Catalog Designation": "May Catalog", label: "May Catalog", value: 5 },
      //   { ID: 6, "Catalog Designation": "June Catalog", label: "June Catalog", value: 6 },
      //   { ID: 7, "Catalog Designation": "July Catalog", label: "July Catalog", value: 7 },
      //   { ID: 8, "Catalog Designation": "August Catalog", label: "August Catalog", value: 8 },
      //   { ID: 9, "Catalog Designation": "September Catalog", label: "September Catalog", value: 9 },
      //   { ID: 10, "Catalog Designation": "October Catalog", label: "October Catalog", value: 10 },
      //   { ID: 11, "Catalog Designation": "November Catalog", label: "November Catalog", value: 11 },
      //   { ID: 12, "Catalog Designation": "December Catalog", label: "December Catalog", value: 12 }
      // ]} 
      placeholder="Select LE Catalog Designation" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                    </div>                    
                    <div class="form-group">
                    <label class="required">Tax Category</label>
                    <input type="text" value={taxCategory} />

                   
                  </div>
                  <div class="form-group" style={{marginTop:"6px"}}>
                        <label>Trend Category</label>
                        <input type="text" />
                    </div>  
                </div>
            </div> 

             <div class="section section-orange">
                <h2 >WEB INFO SECTION</h2>

                <div class="grid grid-2 web_switchs">
                  <div class="row">
                    <div class="col-sm-2">
                    <div class="switchs">

                    <div class="form-group">
                          <label>Available On Web</label>

                          <div className="choking_hazard_checkbox">
                            <label className={`switch3 ${availableOnWeb ? "switch3-checked" : ""}`}>
                              <input type="checkbox" checked={availableOnWeb} />
                              <div></div>
                            </label>
                          </div>

                  </div>

 

                    </div>
                    </div>
                    <div class="col-sm-10">


                    <div class="form-group">
                        <label>Web Description</label>
                        <input type="text" value={webDescription} />

                        {/* <RichTextEditor value={webDescription}     placeholder="Enter Web Description.."  />        */}
                    </div>

                    </div>
                  </div>

                </div>

                <div class="grid grid-1">

                    
                    <div class="form-group">
                        <label>Web Short Description</label>
                        <RichTextEditor value={webShortDescription}      placeholder="Enter Web Description.."  />       
                    </div>

                    <div class="form-group">
                        <label>Web Long Description</label>
                        <RichTextEditor value={webLongDescription}    placeholder="Enter Web Description.."  />       
                    </div>

                    <div class="grid grid-4">

                    <div class="form-group">
                        <label>Metawords</label>
                        <input type="text" value={metawords} />
                    </div>

                        <div class="form-group">
                            <label>Item Interests</label>
                            {/* <Multiselect
                                                                 id="iteminterest"
                                                                 displayValue="label"
                                                                 // ref={multiselectRef}
                                                                 selectedValues={interests}
                                                                 
                                                                 placeholder=""
                                                                 hidePlaceholder={true}
                                                                 
                                                                
                                                               /> */}
                                                               <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      // onChange={handleItemInterest}
      // onRemove={handleStoreCode}
       value={interests}
      // options={[
      //   { "value": "3709", "label": "Infant" },
      //   { "value": "3713", "label": "Party Favors" },
      //   { "value": "3714", "label": "Tween" },
      //   { "value": "3720", "label": "Preschool" },
      //   { "value": "3728", "label": "Toddler" },
      //   { "value": "3751", "label": "Pretend Play" },
      //   { "value": "4093", "label": "Books" },
      //   { "value": "4100", "label": "Science" },
      //   { "value": "4120", "label": "Ride-Ons" },
      //   { "value": "4927", "label": "Health and Safety" },
      //   { "value": "7191", "label": "Best Sellers" },
      //   { "value": "7192", "label": "Stuffed Animals" },
      //   { "value": "7193", "label": "Games" },
      //   { "value": "7194", "label": "Boredom Busters" },
      //   { "value": "7194", "label": "Health & Safety" },
      //   { "value": "7195", "label": "Father's Day" },
      //   { "value": "7196", "label": "Arts & Creativity" },
      //   { "value": "7197", "label": "Construction" },
      //   { "value": "7198", "label": "Collectables" },
      //   { "value": "7199", "label": "Bunny Buffet" },
      //   { "value": "7200", "label": "Summer" },
      //   { "value": "7201", "label": "Dolls" },
      //   { "value": "7203", "label": "Fashion" },
      //   { "value": "7204", "label": "Accessories" },
      //   { "value": "7205", "label": "Room Decor" },
      //   { "value": "7206", "label": "Mother's Day" },
      //   { "value": "7207", "label": "Musical Toys" },
      //   { "value": "7208", "label": "Fidget Toys" },
      //   { "value": "7209", "label": "Travel Toys" },
      //   { "value": "7210", "label": "Educational" },
      //   { "value": "7211", "label": "Puzzles & Brainteasers" },
      //   { "value": "7212", "label": "S.T.E.A.M" },
      //   { "value": "7213", "label": "Valentine's" },
      //   { "value": "7214", "label": "Spring" },
      //   { "value": "7215", "label": "Gadgets" },
      //   { "value": "7216", "label": "Easter" },
      //   { "value": "7217", "label": "Stocking Stuffers" },
      //   { "value": "7218", "label": "Christmas" },
      //   { "value": "7219", "label": "Winter" },
      //   { "value": "7220", "label": "Personalization" },
      //   { "value": "7221", "label": "Halloween" },
      //   { "value": "9946", "label": "Fall" },
      //   { "value": "10329", "label": "None" },
      //   { "value": "11128", "label": "Classic Wood" },
      //   { "value": "13169", "label": "Custom Gift Boxes" },
      //   { "value": "18927", "label": "Gift Cards" },
      //   { "value": "19016", "label": "Action-Skill-Sports" },
      //   { "value": "19024", "label": "Vehicles and Remote Control" },
      //   { "value": "19027", "label": "Lego" },
      //   { "value": "19029", "label": "Candy" },
      //   { "value": "19033", "label": "Chanukkah" },
      //   { "value": "19042", "label": "Squishmallows" }
      // ]} 
      placeholder="Select Item Interests" 
      className="newselect"
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: '#1967d2',
          primary: 'rgb(3 207 217)',
        },
       
      })}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight:'47px'
        }),
        placeholder: (baseStyles, state) => ({
          ...baseStyles,
          color:'black',
          outline:'none'
        }),
        input: (baseStyles, state) => ({
          ...baseStyles,
          outline:'none'
        })
      }
    
    }
      
    />
                        </div> 

                        <div class="form-group">
                        <label>Shipping Type</label>
                        <input type="text" value={shippingType} />

                        {/* <select class="form-control" id="type"  onChange={(e) => setShippingType(e.target.value)} >
                          <option value=""></option>
                          <option value="Small">Small</option>
                          <option value="Regular">Regular</option>
                          <option value="Large">Large</option>
                          <option value="XL">XL</option>
                          <option value="XXL">XXL</option>
                          <option value="XXXL">XXXL</option>
                        </select> */}
                        </div> 
                        <div class="form-group">
                            <label>Extra Shipping Charge</label>
                            <div className="extra_shipping_charge_checkbox">
                            <label className={`switch3 ${extraShippingCharge ? 'switch3-checked' : ''}`} >
                                    <input type="checkbox" checked={extraShippingCharge} />
                                    <div></div>
                            </label>
                            </div>
                        </div> 
                      

                    </div>

                </div>
                <div class="grid grid-4">
                <div class="form-group">
                <label>Image 1</label>
                {/* <ImageUpload id="1" image={image1} onImageChange={(file) => setImage1(file)} /> */}
                <input type="file" class="form-control" accept="image/*" />
                  </div>
                  <div class="form-group">
                <label>Image 2</label>
                <input type="file" class="form-control" accept="image/*" />
                {/* <ImageUpload id="2" image={image2} onImageChange={(file) => setImage2(file)} /> */}
                  </div>
                  <div class="form-group">
                <label>Image 3</label>
                <input type="file" class="form-control" accept="image/*" />
                {/* <ImageUpload  id="3" image={image3} onImageChange={(file) => setImage3(file)} /> */}
                  </div>
                  <div class="form-group">
                        <label>Video URL</label>
                        <input type="text"   />
                      </div>               
                  </div>
            </div> 
            {/* {userDetails.usertype.trim() ==="CORP" ? ( */}
               <div class="section section-purple">
               <h2 >ADDITIONAL INFORMATION</h2>
               <div class="grid grid-3">
                   <div class="form-group">
                           <label>Item Status</label>
                           <input type="text" value={status} />
                           {/* <select class="form-control" id="type"   onChange={(e) => setStatus(e.target.value)} >
                           <option value=""></option>
                           <option value="Approved">Approved</option>
                           <option value="In Review">In Review</option>
                           <option value="Pending Review">Pending Review</option>
                           <option value="Rejected">Rejected</option>
                           </select> */}
                   </div>
                   <div class="form-group">
                       <label>Reason</label>
                       <input type="text" value={reason}/>
                   </div>                     
               </div>
           </div>
            {/* ):(null)} */}
           
        </form>
        </>
):(
<div class="Card_contend">
<div className="loader">
  <RotatingLines
    visible={true}
    height="96"
    width="96"
    strokeColor="grey"
    strokeWidth="2"
    animationDuration="0.75"
    ariaLabel="rotating-lines-loading"
  />
</div>
</div>
) }


          </div>
        </div>
      </div>





                     </>
        )
    }
